"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[961],{

/***/ 91001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function Footer() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    sx: {
      color: "#ffffff",
      margin: "5rem 0 2rem"
    },
    variant: "body2",
    color: "text.secondary",
    align: "center",
    children: ['Copyright © ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      color: "inherit",
      href: "#",
      children: "That's The Ticket"
    }), ' ', new Date().getFullYear(), "."]
  });
}

/***/ }),

/***/ 90774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$S": function() { return /* binding */ readShows; },
/* harmony export */   "N9": function() { return /* binding */ deleteShow; },
/* harmony export */   "RI": function() { return /* binding */ createShow; },
/* harmony export */   "TV": function() { return /* binding */ readUpcomingShow; },
/* harmony export */   "iM": function() { return /* binding */ readShowsAndSessions; },
/* harmony export */   "iU": function() { return /* binding */ editShow; },
/* harmony export */   "tj": function() { return /* binding */ readShow; }
/* harmony export */ });
/* unused harmony exports readShowDashboard, readShowsDashboard, readShowsAudience, readShowById, readTermsAndConditions */
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53901);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89092);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




var readShowDashboard = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(BACKEND_URL, showId) {
    var res, resJson, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchWithAuth(BACKEND_URL + "/api/backend/v1/shows/dashboard/".concat(showId));

          case 3:
            res = _context.sent;

            if (!(!res.ok || res.status >= 400 && res.status < 600)) {
              _context.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response. Error: ".concat(res.status));

          case 6:
            _context.next = 8;
            return res.json();

          case 8:
            resJson = _context.sent;
            return _context.abrupt("return", new ShowDashboardResponse({
              data: resJson
            }));

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            } else {
              message = 'Unable to load show dashboard';
            }

            return _context.abrupt("return", new ShowDashboardResponse({
              error: message
            }));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));

  return function readShowDashboard(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));
var readShowsDashboard = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(BACKEND_URL) {
    var res, resJson, message;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetchWithAuth(BACKEND_URL + "/api/backend/v1/shows/dashboard");

          case 3:
            res = _context2.sent;

            if (!(!res.ok || res.status >= 400 && res.status < 600)) {
              _context2.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response. Error: ".concat(res.status));

          case 6:
            _context2.next = 8;
            return res.json();

          case 8:
            resJson = _context2.sent;
            return _context2.abrupt("return", new ShowsDashboardResponse({
              data: resJson
            }));

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);

            if (_context2.t0 instanceof Error) {
              message = _context2.t0.message;
            } else {
              message = 'Unable to load shows dashboards';
            }

            return _context2.abrupt("return", new ShowsDashboardResponse({
              error: message
            }));

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 12]]);
  }));

  return function readShowsDashboard(_x3) {
    return _ref2.apply(this, arguments);
  };
}()));
var readShowsAndSessions = /*#__PURE__*/function () {
  var _ref3 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
    var res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/shows/shows-with-sessions");

          case 3:
            res = _context3.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context3.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context3.next = 8;
            return res.json();

          case 8:
            resJson = _context3.sent;
            return _context3.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowsResponseSimplified */ .$r({
              data: resJson === null || resJson === void 0 ? void 0 : resJson.shows
            }));

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](0);

            if (_context3.t0 instanceof Error) {
              message = _context3.t0.message;
            } else {
              message = 'Unable to load shows and sessions';
            }

            return _context3.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowsResponseSimplified */ .$r({
              error: message
            }));

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 12]]);
  }));

  return function readShowsAndSessions() {
    return _ref3.apply(this, arguments);
  };
}();
var readUpcomingShow = /*#__PURE__*/function () {
  var _ref4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
    var res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)("/api/backend/v1/shows/upcoming-show");

          case 3:
            res = _context4.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context4.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context4.next = 8;
            return res.json();

          case 8:
            resJson = _context4.sent;
            return _context4.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowResponseSimplified */ .On({
              data: resJson === null || resJson === void 0 ? void 0 : resJson.show
            }));

          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](0);

            if (_context4.t0 instanceof Error) {
              message = _context4.t0.message;
            } else {
              message = 'Unable to load upcoming shows';
            }

            return _context4.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowResponseSimplified */ .On({
              error: message
            }));

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 12]]);
  }));

  return function readUpcomingShow() {
    return _ref4.apply(this, arguments);
  };
}();
var readShowsAudience = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var res, resJson, message;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return defaultFetch("/api/backend/v1/shows/audience");

          case 3:
            res = _context5.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context5.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context5.next = 8;
            return res.json();

          case 8:
            resJson = _context5.sent;
            return _context5.abrupt("return", new ShowsAudiencePageResponse({
              data: resJson === null || resJson === void 0 ? void 0 : resJson.shows
            }));

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](0);

            if (_context5.t0 instanceof Error) {
              message = _context5.t0.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context5.abrupt("return", new ShowsAudiencePageResponse({
              error: message
            }));

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 12]]);
  }));

  return function readShowsAudience() {
    return _ref5.apply(this, arguments);
  };
}()));
var readShows = /*#__PURE__*/function () {
  var _ref6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(withoutAuth) {
    var res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            if (!withoutAuth) {
              _context6.next = 7;
              break;
            }

            _context6.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)("/api/backend/v1/shows?excludeDeleted=true");

          case 4:
            _context6.t0 = _context6.sent;
            _context6.next = 10;
            break;

          case 7:
            _context6.next = 9;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/shows?excludeDeleted=true");

          case 9:
            _context6.t0 = _context6.sent;

          case 10:
            res = _context6.t0;

            if (!(res.status >= 400 && res.status < 600)) {
              _context6.next = 13;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 13:
            _context6.next = 15;
            return res.json();

          case 15:
            resJson = _context6.sent;
            return _context6.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowsResponse */ .m7({
              data: resJson === null || resJson === void 0 ? void 0 : resJson.shows
            }));

          case 19:
            _context6.prev = 19;
            _context6.t1 = _context6["catch"](0);

            if (_context6.t1 instanceof Error) {
              message = _context6.t1.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context6.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowsResponse */ .m7({
              error: message
            }));

          case 23:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 19]]);
  }));

  return function readShows(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
var readShow = /*#__PURE__*/function () {
  var _ref7 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(showIdentifier) {
    var res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)("/api/backend/v1/shows/".concat(showIdentifier));

          case 3:
            res = _context7.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context7.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context7.next = 8;
            return res.json();

          case 8:
            resJson = _context7.sent;
            return _context7.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowResponse */ .LE({
              data: resJson
            }));

          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](0);

            if (_context7.t0 instanceof Error) {
              message = _context7.t0.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context7.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowResponse */ .LE({
              error: message
            }));

          case 16:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 12]]);
  }));

  return function readShow(_x5) {
    return _ref7.apply(this, arguments);
  };
}();
var readShowById = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(showId) {
    var res, resJson, message;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return fetchWithAuth("/api/backend/v1/shows/".concat(showId));

          case 3:
            res = _context8.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context8.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context8.next = 8;
            return res.json();

          case 8:
            resJson = _context8.sent;
            return _context8.abrupt("return", new GetShowResponse({
              data: resJson
            }));

          case 12:
            _context8.prev = 12;
            _context8.t0 = _context8["catch"](0);

            if (_context8.t0 instanceof Error) {
              message = _context8.t0.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context8.abrupt("return", new GetShowResponse({
              error: message
            }));

          case 16:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 12]]);
  }));

  return function readShowById(_x6) {
    return _ref8.apply(this, arguments);
  };
}()));
var readTermsAndConditions = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(showId) {
    var url, res, message;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            url = "/api/backend/termsandconditions?showId=".concat(showId);
            _context9.next = 4;
            return defaultFetch(url);

          case 4:
            res = _context9.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context9.next = 7;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 7:
            return _context9.abrupt("return", res);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](0);

            if (_context9.t0 instanceof Error) {
              message = _context9.t0.message;
            } else {
              message = 'Unable to fetch Terms and Conditions';
            }

            return _context9.abrupt("return", {
              error: message
            });

          case 14:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 10]]);
  }));

  return function readTermsAndConditions(_x7) {
    return _ref9.apply(this, arguments);
  };
}()));
var createShow = /*#__PURE__*/function () {
  var _ref10 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(show) {
    var image, termsAndConditions, fileKeys, body, _iterator, _step, key, _iterator2, _step2, fileKey, res, resText, showId, message;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            image = show.image;
            termsAndConditions = show.termsAndConditions;
            fileKeys = ['name', 'type'];
            body = new FormData();
            _iterator = _createForOfIteratorHelper(Object.keys(show));
            _context10.prev = 6;

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context10.next = 17;
              break;
            }

            key = _step.value;

            if (!(key === 'image' || key === 'termsAndConditions')) {
              _context10.next = 12;
              break;
            }

            return _context10.abrupt("continue", 15);

          case 12:
            if (!(show[key] === null || show[key] === undefined)) {
              _context10.next = 14;
              break;
            }

            return _context10.abrupt("continue", 15);

          case 14:
            body.append("Show.".concat(key), show[key]);

          case 15:
            _context10.next = 8;
            break;

          case 17:
            _context10.next = 22;
            break;

          case 19:
            _context10.prev = 19;
            _context10.t0 = _context10["catch"](6);

            _iterator.e(_context10.t0);

          case 22:
            _context10.prev = 22;

            _iterator.f();

            return _context10.finish(22);

          case 25:
            if (image instanceof Blob) {
              body.append('Image', image);
            }

            if (termsAndConditions != null) {
              body.append("TermsAndConditions", termsAndConditions);
              _iterator2 = _createForOfIteratorHelper(fileKeys);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  fileKey = _step2.value;
                  body.append("TermsAndConditions.".concat(fileKey), termsAndConditions[fileKey]);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }

            _context10.next = 29;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/shows", {
              method: 'POST',
              body: body
            });

          case 29:
            res = _context10.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context10.next = 36;
              break;
            }

            _context10.next = 33;
            return res.text();

          case 33:
            resText = _context10.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 36:
            _context10.next = 38;
            return res.text();

          case 38:
            showId = _context10.sent;
            return _context10.abrupt("return", {
              showId: showId
            });

          case 42:
            _context10.prev = 42;
            _context10.t1 = _context10["catch"](0);

            if (_context10.t1 instanceof Error) {
              message = _context10.t1.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context10.abrupt("return", {
              error: message
            });

          case 46:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 42], [6, 19, 22, 25]]);
  }));

  return function createShow(_x8) {
    return _ref10.apply(this, arguments);
  };
}();
var editShow = /*#__PURE__*/function () {
  var _ref11 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(show) {
    var image, termsAndConditions, fileKeys, body, key, _iterator3, _step3, fileKey, res, resText, message;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            image = show.image;
            termsAndConditions = show.termsAndConditions;
            fileKeys = ['name', 'type'];
            body = new FormData();
            _context11.t0 = _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().keys(show);

          case 6:
            if ((_context11.t1 = _context11.t0()).done) {
              _context11.next = 15;
              break;
            }

            key = _context11.t1.value;

            if (!(key === 'image' || key === 'termsAndConditions')) {
              _context11.next = 10;
              break;
            }

            return _context11.abrupt("continue", 6);

          case 10:
            if (!(show[key] === null || show[key] === undefined)) {
              _context11.next = 12;
              break;
            }

            return _context11.abrupt("continue", 6);

          case 12:
            body.append("Show.".concat(key), show[key]);
            _context11.next = 6;
            break;

          case 15:
            if (image instanceof Blob) {
              body.append('Image', image);
            }

            if (termsAndConditions != null) {
              body.append("TermsAndConditions", termsAndConditions);
              _iterator3 = _createForOfIteratorHelper(fileKeys);

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  fileKey = _step3.value;
                  body.append("TermsAndConditions.".concat(fileKey), termsAndConditions[fileKey]);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }

            _context11.next = 19;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/shows", {
              method: 'PUT',
              body: body
            });

          case 19:
            res = _context11.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context11.next = 26;
              break;
            }

            _context11.next = 23;
            return res.text();

          case 23:
            resText = _context11.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 26:
            return _context11.abrupt("return", res);

          case 29:
            _context11.prev = 29;
            _context11.t2 = _context11["catch"](0);

            if (_context11.t2 instanceof Error) {
              message = _context11.t2.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context11.abrupt("return", {
              error: message
            });

          case 33:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 29]]);
  }));

  return function editShow(_x9) {
    return _ref11.apply(this, arguments);
  };
}();
var deleteShow = /*#__PURE__*/function () {
  var _ref12 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12(showId) {
    var res, resText, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/shows/".concat(showId), {
              method: 'DELETE'
            });

          case 3:
            res = _context12.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context12.next = 10;
              break;
            }

            _context12.next = 7;
            return res.text();

          case 7:
            resText = _context12.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 10:
            _context12.next = 17;
            break;

          case 12:
            _context12.prev = 12;
            _context12.t0 = _context12["catch"](0);
            message = 'Unable to delete session';

            if (_context12.t0 instanceof Error) {
              message = _context12.t0.message;
            }

            return _context12.abrupt("return", {
              error: message
            });

          case 17:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 12]]);
  }));

  return function deleteShow(_x10) {
    return _ref12.apply(this, arguments);
  };
}();

/***/ })

}]);